import { css, html, LitElement } from "lit"
import "../fonctionnels/MaRecherche.js"
import "../popups/PopupAjoutMonPokemon.js"
import "../popups/PopupTri.js"
import PopupBase from "@luminecence/composants/PopupBase"
import Toast, { TOAST_TYPES } from "@luminecence/composants/Toast"
import GestionnaireChangementConnexion from "../connexion/GestionnaireChangementConnexion.js"
import { EVENEMENT_MODIFIER_POKEMON_AMI, EVENEMENT_SUPPRIMER_POKEMON_AMI } from "../fonctionnels/ListePokemons.js"
import { TRI } from "../popups/PopupTri.js"
import "@luminecence/composants/PopupInformation"
import { genererIdentifiantAleatoire } from "../transverse/Utilitaire.js"

const STRATEGIES_DE_TRI = {
  [TRI.AZ.type]: (a, b) => a.nom.localeCompare(b.nom),
  [TRI.ZA.type]: (a, b) => b.nom.localeCompare(a.nom),
  [TRI.SHINY.type]: (a, b) => {
    const aShiny = a.specificites.shiny ? 1 : 0,
      bShiny = b.specificites.shiny ? 1 : 0

    return bShiny - aShiny
  },
  [TRI.PARFAIT.type]: (a, b) => {
    const aParfait = a.specificites.parfait ? 1 : 0,
      bParfait = b.specificites.parfait ? 1 : 0

    return bParfait - aParfait
  },
}
const LIMITE_POKEMONS = 10

export default class PageMaRecherche extends LitElement {
  static properties = {
    idCommunaute: { type: String },
    listePokemonsRecherchee: { type: Array, state: true },
  }

  static styles = css`
        :host {
            display: flex;
            flex-direction: column;
            gap: 2rem;
            padding: 1rem;
        }

        span.titre {
            display: flex;
            align-items: center;
            gap: 1rem;
        }

        .groupe-titre {
            display: flex;
            align-items: baseline;
            gap: 1rem;
        }

        p-bouton-icone {
            display: inline-flex;
        }

        #zone-actions-ma-recherche {
            margin-left: auto;
            min-width: 9rem;
        }

        .liste {
            overflow: hidden;
            transition: max-height 0.4s cubic-bezier(.4,0,.2,1), opacity 0.3s;
            max-height: var(--liste-max-height, 5000px);
            opacity: 1;
        }
    `

  /** @type {GestionnaireChangementConnexion} */
  gestionnaireChangementConnexion = null

  /** @type {ResizeObserver} */
  resizeObserver = null

  gestionChangementVisibilite = () => {
    if (document.visibilityState !== "visible") {
      return
    }

    const user = window.authentification.getUser()

    if (user) {
      this.chargerDonneesUtilisateur()
    } else {
      this.raz()
    }
  }

  constructor() {
    super()

    this.idCommunaute = ""
    this.listePokemonsRecherchee = []
  }

  connectedCallback() {
    super.connectedCallback()
    this.addEventListener(EVENEMENT_MODIFIER_POKEMON_AMI, (event) => this.modifierPokemon(event))
    this.addEventListener(EVENEMENT_SUPPRIMER_POKEMON_AMI, (event) => this.supprimerPokemon(event))
    document.addEventListener("visibilitychange", this.gestionChangementVisibilite)
    this.chargerDonneesUtilisateur()

    this.gestionnaireChangementConnexion = window.authentification.gestionnaireChangementConnexion

    const fonctionDeclenchementCallbacksConnexion = async () => {
      await this.chargerDonneesUtilisateur()
    }
    const fonctionDeclenchementCallbacksDeconnexion = () => {
      this.raz()
    }
    this.gestionnaireChangementConnexion.callbackUtilisateurConnecte.push(fonctionDeclenchementCallbacksConnexion)
    this.gestionnaireChangementConnexion.callbackUtilisateurDeconnecte.push(fonctionDeclenchementCallbacksDeconnexion)
  }

  disconnectedCallback() {
    document.removeEventListener("visibilitychange", this.gestionChangementVisibilite)
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
    super.disconnectedCallback()
  }

  async chargerDonneesUtilisateur() {
    const user = window.authentification.getUser()

    if (!user) {
      return
    }

    this.listePokemonsRecherchee = await window.authentification.bdd.pokemons.recupererLesPokemonsDuMembreConnecte(user.uid, this.idCommunaute)
    this.listePokemonsRecherchee.sort(STRATEGIES_DE_TRI[TRI.AZ.type])
  }

  render() {
    return html`
            ${
              !window.authentification.getUser()
                ? html`<h2 class="titre-connexion"> Inscrit toi ou connecte toi pour accéder à ta recherche !</h2>`
                : this.genererPage()
            }
                `
  }

  async updated() {
    await this.updateComplete
    const pMaRecherche = this.shadowRoot?.querySelector("p-ma-recherche")
    if (pMaRecherche?.updateComplete) {
      await pMaRecherche.updateComplete
    }
    requestAnimationFrame(() => this.calculerMaxHeightListe())
    this.observerListe()
  }

  observerListe() {
    const listeDiv = this.shadowRoot?.querySelector(".liste")
    if (listeDiv && !this.resizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.calculerMaxHeightListe()
      })
      this.resizeObserver.observe(listeDiv)
    }
  }

  calculerMaxHeightListe() {
    const listeDiv = this.shadowRoot?.querySelector(".liste")
    if (listeDiv) {
      const hauteurReelle = listeDiv.scrollHeight
      this.style.setProperty("--liste-max-height", `${hauteurReelle}px`)
    }
  }

  genererPage() {
    return html`<div id="ma-recherche">
                        <span class="titre">
                                <span class="groupe-titre">
                                        <h1>Je recherche </h1> <span>(${this.listePokemonsRecherchee.length}/${LIMITE_POKEMONS})</span>
                                </span>
                                    <div id="zone-actions-ma-recherche">
                                        ${html`<p-bouton-icone id="ajouter-pokemon" icone="ajouter-pokemon" @click=${this.ajouterAMaRecherche}></p-bouton-icone>`}
                                        ${html`<p-bouton-icone id="trier-ma-recherche" icone="tri" @click=${this.trierMaRecherche}></p-bouton-icone>`}
                                </div>
                            </span>
                        ${this.genererZoneMaRecherche()}
                </div>`
  }

  genererZoneMaRecherche() {
    return this.listePokemonsRecherchee.length > 0
      ? html`<div class="liste">
                                <p-ma-recherche .listePokemonsRecherchee=${this.listePokemonsRecherchee} .estModeAmis=${false}></p-ma-recherche>
                        </div>`
      : html`<span>Vous n'avez pas encore ajouté de pokémon à votre liste de recherche.</span>`
  }

  raz() {
    this.listePokemonsRecherchee = []
  }

  /**
   * Fonction affichant et gérant la popup d'ajout d'un pokemon à la liste des pokémons que je recherche
   * @param {CustomEvent} event
   */
  async ajouterAMaRecherche(event) {
    event.stopPropagation()
    if (this.listePokemonsRecherchee.length < LIMITE_POKEMONS) {
      const resultat = await PopupBase.ouvrirEtAttendre("p-popup-ajout-mon-pokemon")

      if (resultat) {
        const { nom, shiny, parfait, chanceux, dynamax, gigamax, fond, commentaire, sexe } = resultat,
          id = genererIdentifiantAleatoire(),
          pokemon = {
            nom,
            id,
            specificites: { shiny, parfait, chanceux, dynamax, gigamax, fond, sexe },
            commentaire,
            communautes: this.idCommunaute ? [this.idCommunaute] : [],
          }

        this.listePokemonsRecherchee.push(pokemon)
        this.listePokemonsRecherchee.sort(STRATEGIES_DE_TRI[TRI.AZ.type])
        this.listePokemonsRecherchee = [...this.listePokemonsRecherchee]
        window.authentification.bdd.pokemons.ajouterUnPokemon(pokemon)
        Toast.afficher(`${pokemon.nom} a été ajouté à votre liste de recherche !`, TOAST_TYPES.SUCCES)
      }
    } else {
      await PopupBase.ouvrirEtAttendre("p-popup-information", {
        titre: "Limite atteinte",
        texte: `Vous avez atteint la limite de ${LIMITE_POKEMONS} pokémons à échanger. Supprimez-en un pour en ajouter un nouveau.`,
      })
    }
  }

  async trierMaRecherche(event) {
    event.stopPropagation()
    const resultat = await PopupBase.ouvrirEtAttendre("p-popup-tri", {
      triAAfficher: [TRI.AZ, TRI.ZA, TRI.SHINY, TRI.PARFAIT],
    })

    if (resultat) {
      const { valeur } = resultat

      this.listePokemonsRecherchee.sort(STRATEGIES_DE_TRI[valeur])
      this.listePokemonsRecherchee = [...this.listePokemonsRecherchee]
    }
  }

  async modifierPokemon(event) {
    const { pokemon } = event.detail

    const resultat = await PopupBase.ouvrirEtAttendre("p-popup-ajout-mon-pokemon", {
      nomPokemon: pokemon.nom,
      shiny: pokemon.specificites.shiny ?? false,
      parfait: pokemon.specificites.parfait ?? false,
      chanceux: pokemon.specificites.chanceux ?? false,
      dynamax: pokemon.specificites.dynamax ?? false,
      gigamax: pokemon.specificites.gigamax ?? false,
      fond: pokemon.specificites.fond ?? false,
      sexe: pokemon.specificites.sexe ?? "",
      commentaire: pokemon.commentaire ?? "",
    })

    if (resultat) {
      const { nom, shiny, parfait, chanceux, dynamax, gigamax, fond, commentaire, sexe } = resultat,
        specificites = {
          shiny,
          parfait,
          chanceux,
          dynamax,
          gigamax,
          fond,
          sexe,
        }

      const pokemonAModifier = this.listePokemonsRecherchee.find((pokemonDeLaListe) => pokemonDeLaListe.id === pokemon.id)

      pokemonAModifier.nom = nom
      pokemonAModifier.id = pokemon.id
      pokemonAModifier.specificites = specificites
      pokemonAModifier.commentaire = commentaire
      this.listePokemonsRecherchee = [...this.listePokemonsRecherchee]
      await window.authentification.bdd.pokemons.modifierUnPokemon(pokemonAModifier)
    }
  }

  async supprimerPokemon(event) {
    const { id: idPokemon } = event.detail

    const indexPokemonASupprimer = this.listePokemonsRecherchee.findIndex(({ id: idPokemonMaListe }) => idPokemonMaListe === idPokemon)

    if (indexPokemonASupprimer > -1) {
      this.listePokemonsRecherchee.splice(indexPokemonASupprimer, 1)
      this.listePokemonsRecherchee = [...this.listePokemonsRecherchee]
      await window.authentification.bdd.pokemons.supprimerUnPokemon(idPokemon)
    }
  }
}
customElements.define("p-page-ma-recherche", PageMaRecherche)
